import authenticatedRequest from '../authenticatedRequest';
import invariant from 'invariant';
import labelRequest from '../labelRequest';
import { buildAffiliateContextAttribute } from '../utils';

export default function createFastUser({ baseUrl, brandId, country, clientId, logonId, uberToken, maMarketingConsent, gender }) {
    invariant(baseUrl, 'baseUrl is a required param of createFastUser()');
    invariant(brandId, 'brandId is a required param of createFastUser()');
    invariant(country, 'country is a required param of createFastUser()');
    invariant(clientId, 'clientId is a required param of createFastUser()');
    invariant(logonId, 'logonId is a required param of createFastUser()');
    invariant(uberToken, 'uberToken is a required param of createFastUser()');
    invariant(maMarketingConsent, 'maMarketingConsent is a required param of createFastUser()');

    const url = `${baseUrl}wcs/resources/store/${brandId}_${country.toLowerCase()}/guestidentity/fastuser`;
    const headers = { 'Content-Type': 'application/json' };
    const body = {
        email: logonId,
        updateSelfAddress: 'true',
        registrationSource: 'Web',
        contextAttribute: [
            {
                attributeName: 'maMarketingConsent',
                attributeValue: {
                    value: maMarketingConsent,
                },
            },
            ...buildAffiliateContextAttribute(),
        ],
        ...(gender && { gender }),
    };

    return labelRequest(authenticatedRequest(new Request(url, { headers, method: 'POST', body: JSON.stringify(body) }), uberToken, clientId), 'createFastUser');
}
